import { render } from "./Summary.vue?vue&type=template&id=0145b588&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=0145b588&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0145b588"

export default script